import { render, staticRenderFns } from "./member-info.vue?vue&type=template&id=195035b6&scoped=true"
import script from "./member-info.vue?vue&type=script&lang=js"
export * from "./member-info.vue?vue&type=script&lang=js"
import style0 from "./member-info.vue?vue&type=style&index=0&id=195035b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195035b6",
  null
  
)

export default component.exports